import { State } from "./state";
import { MutationTree } from "vuex";
import { IS_LOADING, SET_ERROR, SET_SUCCESS, SET_DATA_ITEM, SET_DATA_LIST } from "@/store/Crud/functions/mutations";
import { SET_YT_LINK } from "@/store/UnterrichtDashboard/types";

export default <MutationTree<State>>{
  IS_LOADING,
  SET_ERROR,
  SET_SUCCESS,
  SET_DATA_ITEM,
  SET_DATA_LIST,

  [SET_YT_LINK](state: State, link: any) {
    state.youtubeLink = link;
  },
};
